import React from 'react'
import { Provider } from 'react-redux'

import Analytics from '../classes/analytics'
import Config from '../classes/Config'
import configureStore from '../configureStore'
import Site from './Site'


// Configure Segment.io
Analytics.initialize(Config.SegmentWriteKey)

// Configure the store
const store = configureStore()

export default class Root extends React.Component {
  render () {
    return (
      <Provider store={store}>
        <Site />
      </Provider>
    )
  }
}
